import { useCallback, useEffect, useState } from 'react';
import { getGlp1BridgeAccessStatus } from '../api/glp1BridgeChat';

export const GLP1_PROVIDER_ACCESS_STATUS_ERROR_MESSAGE =
  'We could not confirm existing access. Enter your professional email to send a one-time access code.';

export default function useGlp1BridgeProviderAccess() {
  const [accessLoading, setAccessLoading] = useState(true);
  const [accessUser, setAccessUser] = useState(null);
  const [accessError, setAccessError] = useState(null);

  const refreshAccessStatus = useCallback(async () => {
    setAccessLoading(true);
    setAccessError(null);
    try {
      const status = await getGlp1BridgeAccessStatus();
      setAccessUser(status.authenticated ? status.user : null);
    } catch (error) {
      setAccessUser(null);
      setAccessError(GLP1_PROVIDER_ACCESS_STATUS_ERROR_MESSAGE);
    } finally {
      setAccessLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshAccessStatus();
  }, [refreshAccessStatus]);

  const handleVerified = useCallback((result) => {
    setAccessError(null);
    setAccessUser(result?.user || null);
  }, []);

  return {
    accessLoading,
    accessUser,
    accessError,
    hasAccess: Boolean(accessUser),
    handleVerified,
    refreshAccessStatus,
    setAccessError,
    setAccessUser,
  };
}
